import { render } from "./MultiselectPersonTag.vue?vue&type=template&id=09bcdd37&scoped=true"
import script from "./MultiselectPersonTag.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./MultiselectPersonTag.vue?vue&type=script&charset=utf-8&lang=js"

import "./MultiselectPersonTag.vue?vue&type=style&index=0&id=09bcdd37&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bcdd37"]])

export default __exports__